import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const detail = async (params: object) => {
  return await GET({
    url: Api.detail,
    // headers: {
    //   rpcType: 'dubbo',
    //   'Client-Id': 'iss_courier',
    //   'Content-Type': 'application/json'
    // },
    params,
    showError: false
  })
}
export const list = async (params: object) => {
  return await GET({ url: Api.list, params, showError: false })
}
